import { useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { notify, speak } from "@/lib/api";

const voices = [["coral", "Corail — douce et naturelle"], ["ballad", "Ballad — expressive et enjouée"], ["nova", "Nova — lumineuse"], ["shimmer", "Shimmer — douce"], ["sage", "Sage — posée"], ["alloy", "Alloy — neutre"]];

export default function SettingsPanel() {
  const [voice, setVoice] = useState(localStorage.getItem("semia_voice_v2") || "coral");
  const [auto, setAuto] = useState(localStorage.getItem("lea_autospeak") !== "off");
  const [notif, setNotif] = useState(localStorage.getItem("lea_notif") === "on");

  const pickVoice = async (v) => {
    setVoice(v);
    localStorage.setItem("semia_voice_v2", v);
    try {
      new Audio(await speak("Bonjour, voici ma nouvelle voix.", v)).play();
    } catch {
      toast.error("Aperçu indisponible");
    }
  };

  const toggleNotif = async (on) => {
    if (on && "Notification" in window) {
      const p = await Notification.requestPermission();
      if (p !== "granted") return toast.error("Notifications refusées par le navigateur");
    }
    setNotif(on);
    localStorage.setItem("lea_notif", on ? "on" : "off");
    toast.success(on ? "Notifications activées" : "Notifications désactivées");
  };

  return (
    <div className="card p-6 sm:p-8 space-y-8">
      <h2 className="font-serif text-3xl">Réglages</h2>
      <div>
        <span className="label-mono text-[var(--text-muted)]">Voix de Sem.IA</span>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          {voices.map(([id, label]) => (
            <button key={id} data-testid={`voice-option-${id}`} onClick={() => pickVoice(id)} className={`text-left px-5 py-4 rounded-2xl border transition-colors ${voice === id ? "border-[var(--accent)] bg-[var(--accent-soft)]" : "border-[var(--border)] hover:border-[var(--accent)]"}`}>{label}</button>
          ))}
        </div>
      </div>
      <Row label="Lecture vocale automatique" desc="Sem.IA lit ses réponses à voix haute." testid="autospeak-switch" checked={auto}
        onChange={(v) => { setAuto(v); localStorage.setItem("lea_autospeak", v ? "on" : "off"); }} />
      <Row label="Notifications du navigateur" desc="Être alerté quand une image est prête." testid="notifications-switch" checked={notif} onChange={toggleNotif} />
      <button data-testid="notification-toast-trigger" onClick={() => { toast("Ceci est une notification de test de Sem.IA"); notify("Sem.IA", "Notification de test"); }} className="btn-ghost">Tester une notification</button>
    </div>
  );
}

function Row({ label, desc, testid, checked, onChange }) {
  return (
    <div className="flex items-center justify-between gap-4 py-4 border-t border-[var(--border)]">
      <div>
        <p className="font-medium">{label}</p>
        <p className="text-sm text-[var(--text-muted)]">{desc}</p>
      </div>
      <Switch data-testid={testid} checked={checked} onCheckedChange={onChange} />
    </div>
  );
}
